import Vue from 'vue';

import VueSVGIcon from 'vue-svgicon';
import VeeValidate from 'vee-validate';
import Vuebar from 'vuebar';

import './plugins/vuetify';
import './plugins/vue-meta';
import './plugins/vue-analytics';

import App from './App';
import router from './router';
import { i18n, setLanguage } from './i18n';

import store from './shared/store';

if (location.href.includes('https://www.bitok.biz/sitemap.xml')) {
  location.href = 'https://api.bitok.biz/api/sitemap.xml';
}

Vue.config.productionTip = false;

Vue.use(VeeValidate);
Vue.use(VueSVGIcon);
Vue.use(Vuebar);


/* eslint-disable no-new */
setLanguage()
  .then(() => {
    if (!localStorage.getItem('currencies')) {
      localStorage.setItem('currencies', JSON.stringify({
        baseCurrency: 'BTC',
        baseCurrencyTitle: 'Bitcoin',
        quoteCurrency: 'USDT',
        quoteCurrencyTitle: 'Tether',
        isCrypt: 0,
      }));
    }

    return new Vue({
      el: '#app',
      router,
      store,
      i18n,
      render: h => h(App),
    });
  });



// WEBPACK FOOTER //
// ./src/main.js